import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, Teleport as _Teleport, Transition as _Transition, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "mb-4 border-b border-black-200 pb-24" }
const _hoisted_2 = {
  key: 0,
  class: "mt-16"
}
const _hoisted_3 = {
  key: 0,
  class: "block pb-12 text-20 font-medium text-black-900"
}
const _hoisted_4 = { class: "flex justify-between gap-8 laptop:gap-16" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "center-x absolute -bottom-16 min-w-[60%] whitespace-nowrap rounded border border-black-300 bg-black-200 p-8 text-12 leading-none text-black-700 laptop:-bottom-18 laptop:min-w-[70%] laptop:py-4 laptop:text-14"
}
const _hoisted_7 = { class: "mt-32 flex items-center gap-x-12 uppercase" }
const _hoisted_8 = {
  key: 0,
  class: "text-16 text-black-400"
}
const _hoisted_9 = { class: "text-26 font-medium text-black-900" }
const _hoisted_10 = {
  key: 1,
  class: "badge-small badge-pill badge-primary font-medium uppercase"
}
const _hoisted_11 = {
  key: 2,
  class: "flex flex-1 items-center gap-x-4 text-12"
}
const _hoisted_12 = {
  key: 1,
  class: "py-24 text-black-900"
}
const _hoisted_13 = {
  key: 0,
  class: "block pb-12 text-20 font-medium"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "pointer-events-none relative h-full w-full" }
const _hoisted_16 = {
  key: 0,
  class: "block pt-8 text-12 font-medium tablet:text-14"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "pointer-events-none w-full"
}
const _hoisted_19 = { class: "relative aspect-kit w-full border border-dashed bg-black-100 transition-shadow duration-200 group-hover:shadow-lg" }
const _hoisted_20 = { class: "center-center absolute rounded-full bg-white p-14" }
const _hoisted_21 = { class: "block pt-8 text-12 font-normal tablet:text-14" }
const _hoisted_22 = {
  key: 0,
  class: "pt-24"
}
const _hoisted_23 = {
  key: 0,
  class: "flex flex-col pb-12"
}
const _hoisted_24 = {
  key: 0,
  class: "text-20 font-medium"
}
const _hoisted_25 = {
  key: 1,
  class: "text-12 font-normal text-black-700"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "pointer-events-none relative h-full w-full" }
const _hoisted_28 = {
  key: 0,
  class: "block pt-8 text-12 font-medium tablet:text-14"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 1,
  class: "pointer-events-none w-full"
}
const _hoisted_31 = { class: "relative aspect-kit w-full border border-dashed bg-black-100 transition-shadow duration-200 group-hover:shadow-lg" }
const _hoisted_32 = { class: "center-center absolute rounded-full bg-white p-14" }
const _hoisted_33 = {
  key: 0,
  class: "badge badge-primary badge-small badge-rounded absolute left-8 top-8"
}
const _hoisted_34 = { class: "block pt-8 text-12 font-normal tablet:text-14" }
const _hoisted_35 = {
  key: 1,
  class: "pt-24"
}
const _hoisted_36 = {
  key: 0,
  class: "block pb-12 text-20 font-medium"
}
const _hoisted_37 = { class: "flex items-center justify-evenly gap-x-4 pt-4" }
const _hoisted_38 = { class: "block text-center text-12 font-normal !leading-snug tablet:text-14" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 0,
  class: "tablet:h5 mb-16"
}
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = {
  key: 1,
  class: "flex w-fit cursor-pointer items-center gap-x-8 pt-16 leading-none"
}
const _hoisted_43 = ["checked", "disabled"]
const _hoisted_44 = { class: "text-14 tablet:text-16" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 0,
  class: "fixed bottom-0 left-0 right-0 z-[99] p-16 tablet:hidden"
}
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["value"]
const _hoisted_49 = ["value"]
const _hoisted_50 = ["value"]
const _hoisted_51 = ["value"]
const _hoisted_52 = ["value"]
const _hoisted_53 = ["value"]
const _hoisted_54 = ["value"]
const _hoisted_55 = ["value"]
const _hoisted_56 = ["name", "value"]
const _hoisted_57 = ["value"]
const _hoisted_58 = ["value"]
const _hoisted_59 = ["name", "value"]
const _hoisted_60 = {
  key: 3,
  class: "mt-8 flex items-center gap-x-4 text-12"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_skeleton = _resolveComponent("v-skeleton")
  const _component_v_image = _resolveComponent("v-image")
  const _component_v_icon = _resolveComponent("v-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.product.variants.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($props.setHeadline)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($props.setHeadline), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.product.variants, (variant, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: variant.id,
                type: "button",
                class: _normalizeClass(["btn-xsmall laptop:btn-medium btn-rounded relative w-full border border-black-900 !py-16 hover:bg-black-200 hover:text-black-900", {
            'btn-primary pointer-events-none hover:bg-black-900 hover:text-white':
              index === $data.variantIndex,
            'btn-secondary': index !== $data.variantIndex,
            'line-through': !variant.available,
          }]),
                onClick: $event => ($options.selectVariant(index))
              }, [
                (variant.badge_label && variant.available)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(variant.badge_label), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(variant.title), 1)
              ], 10, _hoisted_5))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      ($options.discountPercentage)
        ? (_openBlock(), _createElementBlock("del", _hoisted_8, _toDisplayString($options.formattedCompareAtPrice), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_9, [
        _createElementVNode("span", null, _toDisplayString($options.formattedPrice), 1)
      ]),
      ($options.discountPercentage)
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, " -" + _toDisplayString($options.discountPercentage) + "% ", 1))
        : _createCommentVNode("", true),
      (!$options.currentVariant.available)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("span", {
              class: "aspect-square w-8 rounded-full",
              style: _normalizeStyle(`background: ${$props.stockIndicator.color_overwrite}`)
            }, null, 4),
            _createElementVNode("p", null, _toDisplayString($data.locale.sold_out), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    ($options.currentVariant.available)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", null, [
            ($props.designHeadline)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString($props.designHeadline), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["grid auto-rows-max grid-cols-3 gap-x-8 gap-y-16 tablet:grid-cols-2 laptop:grid-cols-3", $options.kitItemsQuantity >= 4 && 'desktop:grid-cols-4'])
            }, [
              ($data.isPrefillingKit)
                ? (_openBlock(), _createBlock(_component_v_skeleton, {
                    key: 0,
                    rep: $options.kitItemsQuantity,
                    class: "aspect-kit h-full w-full"
                  }, null, 8, ["rep"]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($options.kitItemsQuantity, (item, i) => {
                    return (_openBlock(), _createElementBlock("button", {
                      id: "modal-trigger",
                      key: item,
                      ref_for: true,
                      ref: "itemPicker",
                      type: "button",
                      class: "group relative flex",
                      "data-modal-id": "product-picker",
                      onClick: _withModifiers($event => ($options.openDrawer($event, i)), ["self"])
                    }, [
                      ($data.products[i])
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_v_image, {
                                width: 350,
                                source: $data.products[i].featured_image,
                                class: "aspect-kit w-full object-cover object-center"
                              }, null, 8, ["source"]),
                              ($data.products[i].title)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString($data.products[i].title), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "absolute right-4 top-4 rounded border border-black-200 bg-white p-6 hover:shadow",
                              onClick: $event => ($options.removeItem(i))
                            }, [
                              _createVNode(_component_v_icon, {
                                icon: "close",
                                width: 11,
                                height: 11,
                                color: "#121212"
                              })
                            ], 8, _hoisted_17)
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_v_icon, {
                                  icon: "plus",
                                  width: 13,
                                  height: 13,
                                  color: "#121212"
                                })
                              ])
                            ]),
                            _createElementVNode("span", _hoisted_21, _toDisplayString($data.locale.design) + " " + _toDisplayString(i + 1), 1)
                          ]))
                    ], 8, _hoisted_14))
                  }), 128))
            ], 2)
          ]),
          ($options.allowOptionals)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                ($props.optionalItemsHeadline || $props.optionalItemsSubtitle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      ($props.optionalItemsHeadline)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString($props.optionalItemsHeadline), 1))
                        : _createCommentVNode("", true),
                      ($props.optionalItemsSubtitle)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString($props.optionalItemsSubtitle), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["grid auto-rows-max grid-cols-3 gap-x-8 gap-y-16 tablet:grid-cols-2 laptop:grid-cols-3", {
            'desktop:grid-cols-4': $options.kitOptionalItemsQuantity >= 4 || $options.kitItemsQuantity >= 4,
          }])
                }, [
                  ($data.isPrefillingKit)
                    ? (_openBlock(), _createBlock(_component_v_skeleton, {
                        key: 0,
                        rep: $options.kitOptionalItemsQuantity,
                        class: "aspect-kit h-full w-full"
                      }, null, 8, ["rep"]))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($options.kitOptionalItemsQuantity, (item, i) => {
                        return (_openBlock(), _createElementBlock("button", {
                          id: "modal-trigger",
                          key: item,
                          ref_for: true,
                          ref: "optionalItemPicker",
                          type: "button",
                          class: "optional-picker group relative flex",
                          "data-modal-id": "product-picker",
                          onClick: _withModifiers($event => ($options.openDrawer($event, i + $options.kitItemsQuantity)), ["self"])
                        }, [
                          ($data.products[i + $options.kitItemsQuantity])
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_27, [
                                  _createVNode(_component_v_image, {
                                    width: 350,
                                    source: $data.products[i + $options.kitItemsQuantity].featured_image,
                                    class: "aspect-kit w-full object-cover object-center"
                                  }, null, 8, ["source"]),
                                  ($data.products[i + $options.kitItemsQuantity].title)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString($data.products[i + $options.kitItemsQuantity].title), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "absolute right-4 top-4 rounded border border-black-200 bg-white p-6 hover:shadow",
                                  onClick: $event => ($options.removeItem(i + $options.kitItemsQuantity))
                                }, [
                                  _createVNode(_component_v_icon, {
                                    icon: "close",
                                    width: 11,
                                    height: 11,
                                    color: "#121212"
                                  })
                                ], 8, _hoisted_29)
                              ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, [
                                    _createVNode(_component_v_icon, {
                                      icon: "plus",
                                      width: 13,
                                      height: 13,
                                      color: "#121212"
                                    })
                                  ]),
                                  ($options.optionalItemDiscountPercentage)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, " -" + _toDisplayString($options.optionalItemDiscountPercentage) + "% ", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("span", _hoisted_34, _toDisplayString($data.locale.optional), 1)
                              ]))
                        ], 8, _hoisted_26))
                      }), 128))
                ], 2)
              ]))
            : _createCommentVNode("", true),
          ($options.accessories?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                ($props.accessoriesHeadline)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString($props.accessoriesHeadline), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["grid auto-rows-max grid-cols-3 gap-x-8 gap-y-16 tablet:grid-cols-2 laptop:grid-cols-3", {
            'mobile-xl:grid-cols-4 desktop:grid-cols-4':
              $options.accessories.length >= 4 || $options.kitItemsQuantity >= 4,
          }])
                }, [
                  ($data.isPrefillingKit)
                    ? (_openBlock(), _createBlock(_component_v_skeleton, {
                        key: 0,
                        rep: 2,
                        class: "aspect-kit h-full w-full"
                      }))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($options.accessories, (accessory, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: accessory.id,
                          class: _normalizeClass(["relative transition-all duration-200 ease-linear", {'opacity-40 grayscale': index === 0 && $data.hasOptOutOfOptionalAccessory}])
                        }, [
                          (accessory.featured_image)
                            ? (_openBlock(), _createBlock(_component_v_image, {
                                key: 0,
                                lazyloaded: "",
                                source: accessory.featured_image,
                                "source-mobile": accessory.featured_image,
                                class: "aspect-kit w-full object-cover object-center"
                              }, null, 8, ["source", "source-mobile"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("span", _hoisted_38, _toDisplayString(accessory.title), 1)
                          ]),
                          ($props.isAccessoriesTooltipEnabled && accessory.description)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                id: "modal-trigger",
                                class: "absolute right-8 top-8 transition-transform duration-150 hover:scale-105",
                                type: "button",
                                "data-modal-id": "accessory-tooltip",
                                onClick: _withModifiers($event => ($options.showAccessoryTooltip($event, index)), ["self","stop"])
                              }, [
                                _createVNode(_component_v_icon, {
                                  class: "rounded-full border border-white bg-black-900 p-[1px]",
                                  icon: "question",
                                  width: 22,
                                  height: 22,
                                  color: "#fff"
                                })
                              ], 8, _hoisted_39))
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128)),
                  ($props.isAccessoriesTooltipEnabled && $options.accessories?.[$data.accessoryIndex]?.description)
                    ? (_openBlock(), _createBlock(_Teleport, {
                        key: 2,
                        to: "#accessory-tooltip-content"
                      }, [
                        ($options.accessories?.[$data.accessoryIndex]?.title)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_40, _toDisplayString($options.accessories[$data.accessoryIndex].title), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          innerHTML: $options.sanitizeHTML($options.accessories[$data.accessoryIndex].description)
                        }, null, 8, _hoisted_41),
                        _createElementVNode("button", {
                          type: "button",
                          class: "absolute right-16 top-24 tablet:right-32 tablet:top-32",
                          "data-modal-id": "accessory-tooltip",
                          onClick: _cache[0] || (_cache[0] = (...args) => ($options.hideAccessoryTooltip && $options.hideAccessoryTooltip(...args)))
                        }, [
                          _createVNode(_component_v_icon, {
                            icon: "close",
                            width: 17,
                            height: 17,
                            "width-mobile": 14,
                            "height-mobile": 14
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                ($options.optionalAccessoryPrice > 0)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_42, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "filter-checkbox form-checkbox absolute -z-10 opacity-0",
                        checked: $data.hasOptOutOfOptionalAccessory,
                        disabled: $data.isPrefillingKit,
                        onChange: _cache[1] || (_cache[1] = (...args) => ($options.handleAccessoryOptOutCheckbox && $options.handleAccessoryOptOutCheckbox(...args)))
                      }, null, 40, _hoisted_43),
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "tablet:large cursor-pointer" }, null, -1)),
                      _createElementVNode("span", _hoisted_44, _toDisplayString($data.locale.accessory_opt_out) + " " + _toDisplayString($options.accessories[0]?.title), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ($options.currentVariant.available)
      ? (_openBlock(), _createElementBlock("form", {
          key: 2,
          ref: "addToCartForm",
          name: "add_to_cart",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.addToCart && $options.addToCart(...args)), ["prevent"]))
        }, [
          _createElementVNode("button", {
            type: "submit",
            name: "add",
            class: "btn btn-primary btn-pill w-full py-8 text-18 capitalize",
            disabled: $data.isPrefillingKit
          }, _toDisplayString($options.addToCartText), 9, _hoisted_45),
          ($props.stickyEnabled)
            ? (_openBlock(), _createBlock(_Transition, {
                key: 0,
                name: "fade"
              }, {
                default: _withCtx(() => [
                  ($data.isButtonSticky)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("button", {
                          name: "add",
                          class: "btn btn-primary btn-pill w-full py-8 text-18 capitalize",
                          disabled: $data.isPrefillingKit
                        }, _toDisplayString($options.addToCartText), 9, _hoisted_47)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
          $options.currentVariant,
          ...$options.kitItems,
          ...$options.includedAccessories,
          ...$options.kitOptionalItems,
        ], (item, index) => {
            return (_openBlock(), _createElementBlock("input", {
              key: index,
              type: "hidden",
              name: "id[]",
              value: item.id
            }, null, 8, _hoisted_48))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.kitItems, (item, itemIndex) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: itemIndex }, [
              _cache[4] || (_cache[4] = _createElementVNode("input", {
                type: "hidden",
                name: "properties[_KitItemType]",
                value: "item"
              }, null, -1)),
              _createElementVNode("input", {
                type: "hidden",
                name: "properties[_KitUniqueKey]",
                value: itemIndex
              }, null, 8, _hoisted_49),
              _createElementVNode("input", {
                type: "hidden",
                name: "properties[_KitItemPrice]",
                value: $options.formatPrice(item.price)
              }, null, 8, _hoisted_50),
              ($options.currentVariant.allocated_item_cost > 0)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "hidden",
                    name: "properties[_KitAllocatedCost]",
                    value: $options.formatPrice($options.currentVariant.allocated_item_cost * 100)
                  }, null, 8, _hoisted_51))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.includedAccessories, (accessory) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: accessory.id
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("input", {
                type: "hidden",
                name: "properties[_KitItemType]",
                value: "accessory"
              }, null, -1)),
              ($options.findAccessoryMetafieldEntry(accessory.id))
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "hidden",
                    name: "properties[_KitAllocatedCost]",
                    value: $options.formatPrice($options.findAccessoryMetafieldEntry(accessory.id).pricing * 100)
                  }, null, 8, _hoisted_52))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.kitOptionalItems, (item, index) => {
            return (_openBlock(), _createElementBlock("input", {
              key: index,
              type: "hidden",
              name: "properties[_KitOptionalProductStandardPrice]",
              value: item.price
            }, null, 8, _hoisted_53))
          }), 128)),
          _createElementVNode("input", {
            type: "hidden",
            name: "properties[_KitKey]",
            value: $data.kitKey
          }, null, 8, _hoisted_54),
          _createElementVNode("input", {
            type: "hidden",
            name: "properties[_KitSize]",
            value: [$options.currentVariant, ...$options.kitItems, ...$options.includedAccessories].length
          }, null, 8, _hoisted_55),
          _createElementVNode("input", {
            type: "hidden",
            name: `properties[${$data.locale.line_item_part_of}]`,
            value: `${$props.product.title} ${
          $props.product.variants.length > 1 ? `- ${$options.currentVariant.title}` : ''
        }`
          }, null, 8, _hoisted_56),
          ($options.compareAtPrice > $options.price)
            ? (_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "hidden",
                name: "properties[_KitCompareAtPrice]",
                value: $options.compareAtPrice
              }, null, 8, _hoisted_57))
            : _createCommentVNode("", true),
          ($data.hasOptOutOfOptionalAccessory)
            ? (_openBlock(), _createElementBlock("input", {
                key: _ctx.index,
                type: "hidden",
                name: "properties[_KitOptionalAccessoryPrice]",
                value: $options.optionalAccessoryPrice
              }, null, 8, _hoisted_58))
            : _createCommentVNode("", true),
          ($options.deliverableAt)
            ? (_openBlock(), _createElementBlock("input", {
                key: 3,
                type: "hidden",
                name: `properties[${$data.locale.deliverable_at}]`,
                value: $options.deliverableAt
              }, null, 8, _hoisted_59))
            : _createCommentVNode("", true)
        ], 544))
      : _createCommentVNode("", true),
    ($options.currentVariant.available)
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
          ($options.deliverableAt)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", {
                  class: "aspect-square w-8 rounded-full",
                  style: _normalizeStyle(`background: ${$props.stockIndicator.color_overwrite}`)
                }, null, 4),
                _createElementVNode("p", null, _toDisplayString($data.locale.deliverable_at) + " " + _toDisplayString($options.deliverableAt), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("span", {
                  class: "aspect-square w-8 rounded-full",
                  style: _normalizeStyle(`background: ${$props.stockIndicator.color}`)
                }, null, 4),
                _createElementVNode("p", null, _toDisplayString($props.stockIndicator.text), 1)
              ], 64))
        ]))
      : _createCommentVNode("", true),
    ($options.currentVariant.available)
      ? _renderSlot(_ctx.$slots, "default", { key: 4 })
      : _createCommentVNode("", true)
  ]))
}